import React from "react";
import classNames from "classnames";
import {MainCarousel} from "@/widgets/main-carousel";
import {MainHitsCarousel} from "@/widgets/main-hits-carousel";
import {MainNewProductsCarousel} from "@/widgets/main-new-products-carousel";
import {MainSales} from "@/widgets/main-sales";
import {MainCollections} from "@/widgets/main-collections";
import {MainDiamonds} from "@/widgets/main-diamonds";
import {MainWedding} from "@/widgets/main-wedding";
import {MainBlog} from "@/widgets/main-blog";
import {MainRecommendedProducts} from "@/widgets/main-recommended-products";
import styles from "./Index.module.scss";
import BaseLayout from "@/Layouts/BaseLayout"; // Legacy

const Index = (props) => {
    const {mainData = {}, isMobile = false, recommendedProducts} = props;
    const {
        mainSlides = [],
        navigations = [],
        hitsData = {},
        newProductsData = {},
        salesData = {},
        collectionsData = {},
        diamondsData = {},
        weddingData = {},
        blogData = {},
        recommendedData = {},
    } = mainData;

    const sectionClasses = classNames(styles.section, {[styles.offset]: mainSlides.length > 0});

    return (
        <BaseLayout {...props}>
            <div className={sectionClasses}>
                <MainCarousel slides={mainSlides} isMobile={isMobile} navigations={navigations} />
                <MainHitsCarousel
                    products={hitsData.products}
                    titleSection={hitsData.titleSection}
                    link={hitsData.link}
                    linkName={hitsData.linkName}
                />
                <MainNewProductsCarousel
                    products={newProductsData.products}
                    link={newProductsData.link}
                    linkName={newProductsData.linkName}
                    path={newProductsData.path}
                    mobilePath={newProductsData.mobilePath}
                    alt={newProductsData.alt}
                />
                <MainSales
                    sales={salesData.sales}
                    title={salesData.title}
                    description={salesData.description}
                    link={salesData.link}
                    linkName={salesData.linkName}
                    path={salesData.path}
                    mobilePath={salesData.mobilePath}
                    alt={salesData.alt}
                />
                <MainCollections
                    titleSection={collectionsData.titleSection}
                    allCollectionsLink={collectionsData.allCollectionsLink}
                    allCollectionsLinkName={collectionsData.allCollectionsLinkName}
                    sets={collectionsData.sets}
                />
                <MainDiamonds
                    cards={diamondsData.cards}
                    path={diamondsData.path}
                    mobilePath={diamondsData.mobilePath}
                    link={diamondsData.link}
                    linkName={diamondsData.linkName}
                    alt={diamondsData.alt}
                    isMobile={isMobile}
                />
                <MainWedding
                    titleSection={weddingData.titleSection}
                    link={weddingData.link}
                    linkName={weddingData.linkName}
                    cards={weddingData.cards}
                    isMobile={isMobile}
                />
                <MainBlog
                    titleSection={blogData.titleSection}
                    link={blogData.link}
                    linkName={blogData.linkName}
                    articles={blogData.articles}
                />
                <MainRecommendedProducts
                    titleSection={recommendedData.titleSection}
                    recommended={recommendedProducts}
                />
            </div>
        </BaseLayout>
    );
};

export default Index;
